import React from "react";

export default function Icon1({ fill = "#138201", stroke = "#61FF00" }) {
  return (
    <svg
      width={189}
      height={214}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#a)">
        <path
          d="M96.327 110.126H60.125A3.124 3.124 0 0 1 57 107.001a3.124 3.124 0 0 1 3.125-3.125h36.202l-7.171-7.171a3.131 3.131 0 0 1 0-4.422 3.131 3.131 0 0 1 4.421 0l12.501 12.5a3.132 3.132 0 0 1 0 4.422l-12.5 12.5a3.123 3.123 0 0 1-2.204.921 3.115 3.115 0 0 1-2.203-.922 3.132 3.132 0 0 1 0-4.422l7.156-7.156ZM119.5 57.001H78.875c-6.89 0-12.5 5.61-12.5 12.5v21.875a3.124 3.124 0 1 0 6.25 0V69.5a6.248 6.248 0 0 1 6.25-6.25h40.624a6.248 6.248 0 0 1 6.25 6.25v75a6.248 6.248 0 0 1-6.25 6.249H78.875a6.247 6.247 0 0 1-6.25-6.249v-21.11a3.114 3.114 0 0 0-3.124-3.125 3.114 3.114 0 0 0-3.125 3.125l-.001 21.109c0 6.89 5.61 12.5 12.5 12.5H119.5c6.89 0 12.5-5.61 12.5-12.5l-.001-75c0-6.891-5.609-12.5-12.499-12.5v.001Z"
          fill={fill}
        />
        <path
          d="M95.12 103.376H60.125a3.624 3.624 0 0 0-3.625 3.625 3.624 3.624 0 0 0 3.625 3.625H95.12l-6.303 6.303a3.631 3.631 0 0 0 0 5.129 3.614 3.614 0 0 0 2.557 1.068 3.62 3.62 0 0 0 2.556-1.067l12.501-12.5a3.631 3.631 0 0 0 0-5.129l-12.5-12.5a3.631 3.631 0 0 0-5.129 0 3.631 3.631 0 0 0 0 5.128l6.318 6.318ZM119.5 56.5h-.489v.001H78.875c-7.167 0-13 5.834-13 13v21.875a3.624 3.624 0 1 0 7.25 0V69.5a5.748 5.748 0 0 1 5.75-5.75h40.624a5.748 5.748 0 0 1 5.75 5.75v75a5.747 5.747 0 0 1-5.75 5.749H78.875a5.747 5.747 0 0 1-5.75-5.749v-21.11a3.614 3.614 0 0 0-3.624-3.625 3.614 3.614 0 0 0-3.625 3.625l-.001 21.109c0 7.166 5.833 13 13 13H119.5c7.166 0 13-5.833 13-13l-.001-75c0-7.167-5.833-13-12.999-13Z"
          stroke={stroke}
        />
      </g>
      <defs>
        <filter
          id="a"
          x={0}
          y={0}
          width={189}
          height={214}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation={28} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0.492117 0 0 0 0 1 0 0 0 0 0.180833 0 0 0 0.6 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_433_17"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect1_dropShadow_433_17"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
}
